import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {UserModel} from '../../../models/authentication/user.model';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-about-book',
  templateUrl: './about-book.component.html',
  styleUrls: ['./about-book.component.css']
})
export class AboutBookComponent implements OnInit {

  constructor(private router: Router,
              private tSv: TranslateService) { }

  ngOnInit() {

    if (UserModel.getCurrent()) {
      if (this.tSv.currentLang !== UserModel.getCurrent().culture) {
        this.tSv.use(UserModel.getCurrent().culture);
      }
    }

  }

  onNextClicked() {
    this.router.navigate(['platform', 'dash']);
  }

}
